// extracted by mini-css-extract-plugin
export var img = "style-module--img--qKO5Z";
export var img__absolute = "style-module--img__absolute--bob6L";